import React from 'react'
import AddListingSection from './components/AddListingSection'
import Header from '../../common/Header'
import FooterDashBoard from '../../common/FooterDashBoard'
import DashBoardSideBar from '../../common/DashBoardSideBar'
import DashBoardHeader from '../../common/DashBoardHeader'

const AddListing = () => {
  return (
     <div className="boxcar-wrapper v2" >
      <DashBoardHeader dashBoardHeader={true} />
      <section className="dashboard-widget">
        <div className="right-box">
          <DashBoardSideBar />
          <AddListingSection/>

          {/* <AddList/> */}
        </div>
      </section>
      <FooterDashBoard />
    </div>
  )
}

export default AddListing
